import _ from "lodash";
import { formatServerErrors } from "../config";
import QboxmailApi from "../qboxmailApi";
import * as sessionActions from "./session.js";
import { alertError } from "Utils/alerts";
import { t } from "i18next";

const REFRESH_RESOURCES = "REFRESH_RESOURCES";
const REFRESH_RESOURCES_SUCCESS = "REFRESH_RESOURCES_SUCCESS";
const REFRESH_RESOURCES_FAIL = "REFRESH_RESOURCES_FAIL";
const GET_RESOURCES = "GET_RESOURCES";
const SET_RESOURCE = "SET_RESOURCE";
const GET_RESOURCES_SUCCESS = "GET_RESOURCES_SUCCESS";
const GET_RESOURCES_FAIL = "GET_RESOURCES_FAIL";
const CREATE_RESOURCE = "CREATE_RESOURCE";
const CREATE_RESOURCE_SUCCESS = "CREATE_RESOURCE_SUCCESS";
const CREATE_RESOURCE_FAIL = "CREATE_RESOURCE_FAIL";
const UPDATE_RESOURCE_LIMITS_EXCEEDED = "UPDATE_RESOURCE_LIMITS_EXCEEDED";
const CREATE_RESOURCE_LIMITS_EXCEEDED = "CREATE_RESOURCE_LIMITS_EXCEEDED";
const UPDATE_RESOURCE = "UPDATE_RESOURCE";
const UPDATE_RESOURCE_SUCCESS = "UPDATE_RESOURCE_SUCCESS";
const UPDATE_RESOURCE_FAIL = "UPDATE_RESOURCE_FAIL";
const CLEAR_REDIRECT = "CLEAR_REDIRECT";
const CHANGE_ATTRIBUTE_VALUE = "CHANGE_ATTRIBUTE_VALUE";
const DELETE_RESOURCES = "DELETE_RESOURCES";
const DELETE_RESOURCES_SUCCESS = "DELETE_RESOURCES_SUCCESS";
const OPTIMISTICALLY_DELETE_RESOURCE = "OPTIMISTICALLY_DELETE_RESOURCE";
const RESET_RESOURCE = "RESET_RESOURCE";
const RESET_STORE = "RESET_STORE";

export const isResourceLoading = (key, state) =>
  state.resources[key] ? state.resources[key].loading || state.resources[key].loading === undefined : true;
export const getData = (key, state) => key.split(".").reduce((a, b) => a[b] || {}, state.resources);

export const isResourceRefreshing = (key, state) =>
  state.resources[key] ? state.resources[key].refreshResource : false;

const initialState = {};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case RESET_STORE:
      return initialState;
    case REFRESH_RESOURCES:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          refreshResource: true,
          loading: false,
        },
      };

    case GET_RESOURCES:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: !action.appending && true,
          isAppending: action.appending,
        },
      };

    case SET_RESOURCE:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          data: action.data,
        },
      };

    case REFRESH_RESOURCES_SUCCESS:
    case GET_RESOURCES_SUCCESS:
      newData = undefined;
      let noMoreData = false;
      let newPaginationData;
      if (action.appending) {
        if (action.data.resources.length === 0) {
          noMoreData = true;
        }
        newData = state[action.resourcesType].data.concat(action.data.resources);
        newPaginationData = {
          last: action.data.pagination.last,
        };
      } else {
        newData = action.data.resources;
        newPaginationData = action.data.pagination;
      }

      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          data: newData,
          paginationInfo: {
            ...state[action.resourcesType].paginationInfo,
            ...newPaginationData,
          },
          errors: [],
          refreshResource: false,
          loadingUpdate: false,
          isAppending: false,
          noMoreData,
        },
      };

    case REFRESH_RESOURCES_FAIL:
    case GET_RESOURCES_FAIL:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          errors: formatServerErrors(action.errors.errors),
          data: [],
          refreshResource: false,
        },
      };
    // POST
    case CREATE_RESOURCE:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: true,
        },
      };

    case CREATE_RESOURCE_SUCCESS:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          redirectTo: action.redirectTo ? action.redirectTo : false,
          data: [action.data],
        },
      };

    case CREATE_RESOURCE_FAIL:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          errors: formatServerErrors(action.errors.errors),
          message: undefined,
        },
      };

    case UPDATE_RESOURCE_LIMITS_EXCEEDED:
    case CREATE_RESOURCE_LIMITS_EXCEEDED:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          message: action.message,
          loadingUpdate: false,
          errors: [],
        },
      };
    // PUT
    case UPDATE_RESOURCE:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loadingUpdate: true,
        },
      };

    case UPDATE_RESOURCE_SUCCESS:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loadingUpdate: false,
          refreshResource: action.refreshResource,
          errors: [],
          message: undefined,
        },
      };

    case UPDATE_RESOURCE_FAIL:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loadingUpdate: false,
          errors: formatServerErrors(action.errors),
        },
      };

    case CLEAR_REDIRECT:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          redirectTo: undefined,
        },
      };
    // DELETE
    case DELETE_RESOURCES:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          deleting: true,
        },
      };

    case DELETE_RESOURCES_SUCCESS:
      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          loading: false,
          refreshResource: action.refreshResource,
          deleting: false,
        },
      };

    case CHANGE_ATTRIBUTE_VALUE:
      let newData = [];
      _.each(state[action.resourcesType].data, (res) => {
        let newResource = Object.assign({}, res);
        if (res.code === action.resourceCode) {
          newResource[action.resourceAttribute] = action.newValue;
        }
        newData.push(newResource);
      });

      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          data: newData,
        },
      };

    case OPTIMISTICALLY_DELETE_RESOURCE:
      let data = state[action.resourcesType].data;

      newData = [];
      if (action.resourceId) {
        newData = _.filter(data, (res) => res.id !== action.resourceId);
      } else {
        newData = _.filter(data, (res) => res.code !== action.resourceCode);
      }

      return {
        ...state,
        [action.resourcesType]: {
          ...state[action.resourcesType],
          data: newData,
        },
      };

    case RESET_RESOURCE:
      return {
        ...state,
        [action.resourcesType]: undefined,
      };
    default:
      return state;
  }
}

function loadingFunc(actionType, resourcesType, appending) {
  return {
    type: actionType,
    resourcesType,
    appending,
  };
}

function successFunc(actionType, resourcesType, data, appending) {
  return {
    type: `${actionType}_SUCCESS`,
    data,
    resourcesType,
    appending,
  };
}

function errorFunc(actionType, resourcesType, errors) {
  return {
    type: `${actionType}_FAIL`,
    errors,
    resourcesType,
  };
}

// manually set resource
export function setResource(resourcesType, data) {
  return {
    type: SET_RESOURCE,
    data,
    resourcesType,
  };
}

// reset
export function resetSelectedResource(resourcesType) {
  return {
    type: RESET_RESOURCE,
    resourcesType,
  };
}

// reset whole store (e.g. on logout)
export function resetResourcesStore(resourcesType) {
  return {
    type: RESET_STORE,
  };
}

// takes the name of the method to call on the qboxmailApi
// wrapper, the array of the arguments for the api, the resource name for the reducer
// and passes the rest of the arguments
export function callApi(method, resourceType) {
  let actionType;
  if (method.match(/^get/g)) {
    actionType = GET_RESOURCES;
  } else if (method.match(/^(edit|disable|enable|change)/g)) {
    actionType = UPDATE_RESOURCE;
  } else if (method.match(/^create/g)) {
    actionType = CREATE_RESOURCE;
  } else if (method.match(/^delete/g)) {
    actionType = DELETE_RESOURCES;
  } else if (method.match(/^refresh/g)) {
    actionType = REFRESH_RESOURCES;
  } else if (!actionType) {
    throw new Error("It wasnt possible to determine the action type");
  }

  return (dispatch, getState) => {
    // dispatch the start of the the request
    // the portion of state goes in a 'loading' state

    const args = [...arguments].slice(2);
    const isAppending = args[0] && !!args[0].appending;
    dispatch(loadingFunc(actionType, resourceType, isAppending));
    let client = new QboxmailApi({ useCookie: true });
    try {
      client[method](...args)
        .then((data) => {
          dispatch(successFunc(actionType, resourceType, data, isAppending));
        })
        .catch((response) => {
          if (response.status === 401) {
            console.warn("session expired");
            window.qb_requestedURL = "";

            dispatch(sessionActions.unsetSession());
            dispatch(resetResourcesStore());
          } else if (response.status === 403) {
            console.warn("limiti superati");
          } else if (response.status === 422) {
            response.json().then((data) => {
              dispatch(errorFunc(actionType, resourceType, data.errors));
            });
          } else if (response.status === 500) {
            // calling this here is not a best practice, because it is a side effect
            alertError(t("alert.wrong.contactUs"));
          } else if (response.status === 404) {
            dispatch(
              successFunc(
                actionType,
                resourceType,
                {
                  resources: [],
                  pagination: {
                    total_records: 0,
                  },
                },
                isAppending
              )
            );
          } else {
            console.log("Errore non catturato!", response);
            dispatch(errorFunc(actionType, resourceType, { status: response.status }));
          }

          if (response instanceof Error) {
            throw response;
          }
        });
    } catch (e) {
      console.error("method don't exist on qboxmailApi", e);
    }
  };
}

export function changeAttribute(newValue, options) {
  const { resourcesType, resourceCode, resourceAttribute } = options;

  return {
    type: CHANGE_ATTRIBUTE_VALUE,
    resourcesType,
    resourceAttribute,
    resourceCode,
    newValue,
  };
}

export function optimisticallyDeleteResource(options) {
  const { resourcesType, resourceCode, resourceId } = options;

  return {
    type: OPTIMISTICALLY_DELETE_RESOURCE,
    resourcesType,
    resourceCode,
    resourceId,
  };
}
